import React from 'react';
import './about.css';
import { mData } from './mData';
import { Button } from '@mui/material';

export default function About() {
    return (
        <div id="about" className="mt-5 d-flex flex-column align-items-center">
            {
                mData.map(x => {
                    return <div key={x.title} className='card w-75 my-5 mx-5 text-center card-container'>
                        <div className="card-body">
                            <h1 className='card-title'>{x.title}</h1>
                            {
                                x.image ?
                                    <img src={x.image} alt="" />
                                    : <div></div>
                            }
                            <p className="card-text">
                                {x.body}
                            </p>
                            {
                                x.url ? (
                                    <Button color='primary' variant="contained" disableElevation>
                                        <a href={x.url} className="text-white" style={{ textDecoration: "none" }}>find out more about {x.id}</a>
                                    </Button>
                                ) : null
                            }
                        </div>
                    </div>
                })
            }

        </div>
    )
}
